import Case from './Case'
import Client from './Client'
import Document from './Document'
import Query from './Query'
import User from './User'

export default {
  Case,
  Client,
  Document,
  Query,
  User,
}
